setUserVideoIdPath